import React from 'react'

import { Route } from 'react-router'

import config from 'config/routes'
import { FullPage } from 'layouts/FullPage'

import {
  HowGoustoWorks,
  FoodBox,
  MealPlanning,
  FoodBoxCmsCatchAll,
  HeatAndEat,
  ScratchHeatAndEat,
} from './MarketingPages'

export const HowGoustoFoodBoxesWorkPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.howGoustoWorks} component={HowGoustoWorks} />
  </Route>
)

export const MealPlanningPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.goustoMealPlanning} component={MealPlanning} />
  </Route>
)

export const FoodBoxPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.foodBox} component={FoodBox} />
  </Route>
)

export const FoodBoxCmsCatchAllPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path="/food-box/*" component={FoodBoxCmsCatchAll} />
  </Route>
)

export const HeatAndEatLandingPages = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.landingHeatAndEat} component={HeatAndEat} />
    <Route path={config.client.landingScratchHeatAndEat} component={ScratchHeatAndEat} />
  </Route>
)
